import { Link } from "gatsby"
import PropTypes from "prop-types"
import React, { useEffect } from "react"
import styled, { createGlobalStyle } from "styled-components"
import { collections } from "../../lib/prop-types"

const FixPageScroll = createGlobalStyle`
  html {
    padding-top: ${props => props.theme.layout.header.height};
    overflow: hidden;
  }
`

const DropDown = styled.nav`
  position: absolute;
  width: 100%;
  padding: ${props => props.theme.space.sm} ${props => props.theme.space.md};
  background-color: ${props => props.theme.colors.header.background};
  border-color: ${props => props.theme.colors.header.mobileBorder};
  border-top-width: ${props => props.theme.borderWidths.sm};
  border-top-style: ${props => props.theme.borderStyles.solid};
`

const NavLink = styled(Link)`
  display: block;
  margin: ${props => props.theme.space.xs} 0;
  padding: ${props => props.theme.space.sm} ${props => props.theme.space.xs};
  color: ${props => props.theme.colors.header.textColor};
  text-decoration: none;
  border-radius: ${props => props.theme.borderRadii.md};
  ${props =>
    props.partiallyActive &&
    `background-color: ${props.theme.colors.header.mobileNavLinkActive} !important;`}

  &:hover,
  &:focus {
    color: ${props => props.theme.colors.header.textColor};
    text-decoration: none;
    background-color: ${props => props.theme.colors.header.mobileNavLinkHover};
  }

  &:focus {
    box-shadow: ${props => props.theme.focusBoxShadow};
  }
`

const MobileDropdown = ({ collection, closeDropdown }) => {
  function handleEscPress(e) {
    const escPressed = e.keyCode === 27
    if (escPressed) {
      closeDropdown()
    }
  }

  useEffect(() => {
    document.addEventListener("keydown", handleEscPress, false)

    return () => {
      document.removeEventListener("keydown", handleEscPress, false)
    }
  }, [])

  return (
    <>
      <FixPageScroll />
      <DropDown
        aria-label="Header navigation"
        role="navigation"
        data-testid="dev-docs-header-dropdown"
        onClick={e => e.stopPropagation()}
      >
        <NavLink
          to="/documentation/"
          aria-current={collection === "documentation"}
          partiallyActive={collection === "documentation"}
        >
          Documentation
        </NavLink>

        <NavLink
          to="/api-reference/"
          aria-current={collection === "api-reference"}
          partiallyActive={collection === "api-reference"}
        >
          API Reference
        </NavLink>
      </DropDown>
    </>
  )
}

MobileDropdown.propTypes = {
  collection: collections.isRequired,
  closeDropdown: PropTypes.func.isRequired
}

export default MobileDropdown
